/* eslint-disable @typescript-eslint/no-require-imports */
import { type TFunction } from 'i18next';
import checkUndefinedNullOrEmpty from '../utils/tools/checkUndefinedNullOrEmpty';

type ErrorCodes = '000' | '001' | '002' | '003' | '004' | '005' | '006a' | '006b' | '006c' | '006d' | '006e' | '006f' | '006g' | '006h' | '007';

export type ConfigErrorType = Error & {
    code: '4x' & ErrorCodes;
};

export class ConfigError extends Error {
    constructor(translate: TFunction, errorCode: ErrorCodes, ...error) {
        super(...error);

        const code = '4x' + errorCode;

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ConfigError);
        }

        if (checkUndefinedNullOrEmpty(translate)) {
            const langDE = require('../locales/de-DE');
            const langDECustomer = require('../locales/customerTexts/de-DE');
            const languageFile = { ...langDE, ...langDECustomer };

            // @ts-ignore
            this.message = `${code} - ${languageFile?.errorHandler?.sIntErrors?.[code]?.title}${code === 'runtimeError' && message ? ' - ' + message : ''}`;
            // @ts-ignore
            this.code = code;
        } else {
            // @ts-ignore
            this.message = `${code} - ${translate('common:errorHandler.sIntErrors.' + code + '.title')}${code === 'runtimeError' && message ? ' - ' + message : ''}`;
            // @ts-ignore
            this.code = code;
        }
    }
}
